export default {"src":"/_next/static/media/unity.8c9f5c81.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};